<script>
import leftImg from '@/assets/images/responsive/home-footer-left.jpeg?min=320&max=800';
import rightImg from '@/assets/images/responsive/home-footer-right.jpg?min=320&max=800';
import ResponsiveImage from '@/components/ResponsiveImage';
import BuyerButton from '@/components/Button';

export default {
  components: {
    ResponsiveImage,
    BuyerButton,
  },
  data: () => ({
    leftImg,
    rightImg,
  }),
  methods: {
    buttonClickFollow() {
      window.open('https://www.instagram.com/viralstyleofficial');
    },
  },
};
</script>

<template lang='pug'>
.mt-3.md_mt-5.flex.container.md_px-1.mx-auto.flex-wrap.md_mb-6
  .w-1-3.hidden.md_block
    responsive-image(
      sizes='(min-width: 768px) 33.33%, 100vw',
      :image-object='leftImg',
      alt-text='Cool looking bro guy with tattoos',
    )

  .w-full.md_w-1-3.bg-brand.flex.items-center.justify-center.text-center.flex-col.py-4.md_py-0
    .text-5xl.md_text-2xl.text-white Welcome to our
    .text-5xl.text-white.font-bold InstaViralWorld
    buyer-button.mt-2_5(
      long,
      large,
      text='FOLLOW',
      @click='buttonClickFollow',
    )
    .text-2xl.md_text-lg.text-white.mt-3 See all that's new on
    .text-2xl.md_text-lg.text-white Instagram #[span.cursor-pointer.font-bold.hover_underline(@click='buttonClickFollow', @keyup.enter='buttonClickFollow') @viralstyleofficial]

  .w-full.md_w-1-3
    responsive-image(
      sizes='(min-width: 768px) 33.33%, 100vw',
      :image-object='rightImg',
      alt-text='Some other really cool looking people.',
    )
</template>

<style>
@import '~import/index';
</style>